import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { USER_REGISTRATION_LOGIN_TYPE } from 'ish-core/configurations/injection-keys';
import { FormSubmitDirective } from 'ish-core/directives/form-submit.directive';
import { AccountFacade } from 'ish-core/facades/account.facade';
import { HttpError } from 'ish-core/models/http-error/http-error.model';
import { InjectSingle } from 'ish-core/utils/injection';
import { ErrorMessageComponent } from 'ish-shared/components/common/error-message/error-message.component';
import { Auth0SignInComponent } from '../auth0-sign-in/auth0-sign-in.component';
import { AzureSignInComponent } from '../azure-sign-in/azure-sign-in.component';

/**
 * The Login Form Page Container displays a login form using the {@link LoginFormComponent} and signs the user in
 * Set the Url query parameter returnUrl as page Url after successful Logging in, e.g.
 * <a
    routerLink="/login"
    [queryParams]="{ returnUrl: '/account' }"
    class="my-account-link my-account-login"
    rel="nofollow"
  >
 *
 * @example:
 * <ish-login-form></ish-login-form>
 */
@Component({
  selector: 'ish-login-form',
  templateUrl: './login-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ErrorMessageComponent,
    ReactiveFormsModule,
    FormSubmitDirective,
    FormlyModule,
    NgClass,
    RouterLink,
    AsyncPipe,
    TranslateModule,
    Auth0SignInComponent,
    AzureSignInComponent,
  ],
})
export class LoginFormComponent implements OnInit {
  loginType = inject<InjectSingle<typeof USER_REGISTRATION_LOGIN_TYPE>>(USER_REGISTRATION_LOGIN_TYPE);
  private accountFacade = inject(AccountFacade);

  readonly labelClass = input<string>(undefined);
  readonly inputClass = input<string>(undefined);
  readonly forgotPasswordClass = input<string>(undefined);
  readonly signInClass = input<string>(undefined);

  loginError$: Observable<HttpError>;

  form = new UntypedFormGroup({});

  fields: FormlyFieldConfig[];
  ngOnInit() {
    this.loginError$ = this.accountFacade.userError$;

    this.fields = this.getFields();
  }

  private getFields() {
    return [
      {
        key: 'login',
        type: this.loginType === 'email' ? 'ish-email-field' : 'ish-text-input-field',
        props: {
          // label: this.loginType === 'email' ? 'account.login.email.label' : 'account.login.username.label',
          // labelClass: this.labelClass || 'col-md-3',
          placeholder: 'Email',
          fieldClass: this.inputClass() || 'col-md-12',
          required: true,
          hideRequiredMarker: true,
        },
        validation: {
          messages: {
            required:
              this.loginType === 'email' ? 'form.email.error.required' : 'account.login.username.error.required',
          },
        },
      },
      {
        key: 'password',
        type: 'ish-password-novalidate-field',
        props: {
          type: 'password',
          placeholder: 'Password',
          // label: 'account.login.password.label',
          // labelClass: this.labelClass || 'col-md-3',
          fieldClass: this.inputClass() || 'col-md-12',
          required: true,
          hideRequiredMarker: true,
        },
        validation: {
          messages: {
            required: 'account.login.password.error.required',
          },
        },
      },
    ];
  }

  loginUser() {
    if (this.form.valid) {
      this.accountFacade.loginUser(this.form.value);
    }
  }
}
